export const B2B_CONTRACT_TYPE = "business_and_technical_cooperation_agreement";

export const isB2B = (contractType?: string | null) =>
  contractType === B2B_CONTRACT_TYPE;
